var map = {
	"./ageas.png": "ea64",
	"./eres.png": "14b1",
	"./generali.png": "0b44",
	"./simulassur.png": "13d7",
	"./swisslife.png": "e9bb",
	"./uaf-life.png": "71b3",
	"./upsideo.png": "6405",
	"./vieplus.png": "1f72"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "70ad";